import React from 'react'
import { FormComponent } from '../../../BaseComponent'
import { Button, Form, Input, message, Select, Switch } from 'antd'
import IKioskReason from '../../../../interfaces/IKioskReason'
import { ShelterKioskReasonCreateRequest } from '../../../../services/api/interfaces/ApiRequest'

type KioskAddShelterReasonProps = {
  branchUuid: string,
  loading: boolean
  kioskReasons: IKioskReason[] | null

  createShelterKioskReason: (args: ShelterKioskReasonCreateRequest) => Promise<any>

  onSave: () => void
}

export default class KioskAddShelterReason extends FormComponent<KioskAddShelterReasonProps> {

  onReasonChange = (reasonUuid) => {
    const { kioskReasons } = this.props

    if (this.formRef) {
      const reason = kioskReasons?.find(v => v.uuid === reasonUuid)
      
      if (reason) {
        this.formRef.setFieldsValue({
          end_message: reason.end_message,
          wait_list_on_end: reason.wait_list_on_end
        })
      }
    }
  }

  handleSave = async (values: any) => {
    const { branchUuid, createShelterKioskReason, onSave } = this.props

    try {
      const payload: ShelterKioskReasonCreateRequest = {
        shelter_kiosk_reason: {
          ...values,
          branch_uuid: branchUuid
        }
      }

      await createShelterKioskReason(payload)

      onSave()
    } catch (err) {
      message.error(`Could not create shelter kiosk reason. Error: ${err}`)
    }
  }

  render() {
    const { loading, kioskReasons } = this.props

    const kioskReasonOptions = kioskReasons?.map(reason => {
      return {
        label: reason.name,
        value: reason.uuid
      }
    })

    const values = {
      wait_list_on_end: false,
      custom_reason_response: false
    }

    return (
      kioskReasons ? 
      <Form
        name="shelter_kiosk_reason"
        ref={(refs) => this.formRef = refs}
        initialValues={values}
        onFinish={this.handleSave}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Choose a name for your reason'
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Kiosk Reason"
          name="reason_uuid"
          rules={[
            {
              required: true,
              message: 'Please select a base kiosk reason'
            }
          ]}
        >
          <Select options={kioskReasonOptions} onChange={this.onReasonChange}/>
        </Form.Item>

        <Form.Item
          label="End message (displayed when user finishes checking in)"
          name="end_message"
          rules={[
            {
              required: true,
              message: 'Choose an end message for the reason'
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Wait list on end"
          name="wait_list_on_end"
          rules={[
            {
              required: true,
              message: 'Required field'
            }
          ]}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item
          label="Custom reason response"
          name="custom_reason_response"
          rules={[
            {
              required: true,
              message: 'Required field'
            }
          ]}
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item style={{marginTop: 32}}>
          <Button type="primary" htmlType="submit" size="large" loading={loading} ref={(refs) => this.actionRefs.save = refs} block>
            Save
          </Button>
        </Form.Item>
      </Form> : <div>You cannot add more reasons, edit the existing ones</div>
    )
  }
}
